// src/axios/privateAxios.js

import axios from "axios"
import { toast } from "react-toastify";

let refreshPromise = null

let apiURL = process.env.REACT_APP_RUN_DOCKER === 'TRUE' ? process.env.REACT_APP_DOCKER_API_URL : process.env.REACT_APP_API_URL
export const axiosInstance = axios.create({
    baseURL: apiURL,
    withCredentials: true
})

axiosInstance.interceptors.request.use((config) => {
  return config;
});

const refreshAuthToken = () => {
    if (!refreshPromise) {
        refreshPromise = axios.post(
            `${apiURL}/users/refresh-token`,
            { rememberMe: localStorage.getItem("rememberMe") === "true" },
            { withCredentials: true }
        ).finally(() => refreshPromise = null)
    }
    return refreshPromise
}

const handleLogout = () => {
    localStorage.removeItem("user")
    localStorage.removeItem("isLoggedIn")
    localStorage.setItem("logout-event", Date.now())
    window.location.href = "/login"
    return new Promise(() => {})
}

export const handleErrorLogout = async (msg) => {
    toast.dismiss()
    toast.loading(
        <span style = {{ fontSize: "13.5px", fontFamily: 'Poppins, sans-serif'}}>
            {msg}
        </span>,
        {
            position: "bottom-left"
        }
    )
    await new Promise(resolve => setTimeout(resolve, 1000))
    return handleLogout()
}

axiosInstance.interceptors.response.use((response)=>{
    return response
},async(error)=>{
    const originalRequest = error.config
    if (error.response?.status === 401) {
        if (error.response?.data?.message === "REFRESH_TOKEN_MISSING") {
            return handleLogout()
        }
        else if (error.response?.data?.message === "USER_NOT_FOUND"){
            const user = typeof window === "undefined" ? {} : JSON.parse(localStorage.getItem("user") ?? "{}")
            if (user?.isDemoUser){
                return await handleErrorLogout("Your demo session has ended — logging out…")
            }
            else{
                return await handleErrorLogout("Your Account no longer exists — logging out…")
            }
        }
        else if (error.response?.data?.message === "PASSWORD_CHANGED") {
            return handleErrorLogout("Your password was changed. Please log in again.")
        }
        else if (error.response?.data?.message === "DEMO_SESSION_EXPIRED") {
            return await handleErrorLogout("Your demo session has ended — logging out…")
        }
        else if (!originalRequest._retry){
            originalRequest._retry = true
            try{
                await refreshAuthToken()
                return axiosInstance(originalRequest)
            }
            catch(err){
                return handleLogout()
            }
        }
        else{
            return handleLogout()
        }
    }
    else{
        return Promise.reject(error)
    }
})
